import { msg } from "@lingui/macro";
import { MessageDescriptor } from "@lingui/core";

const formErrors: Record<string, MessageDescriptor> = {
  ["The email address entered wasn't found in the database!"]: msg`The email address entered wasn't found in the database!`,
  ["It looks like something went wrong our side."]: msg`It looks like something went wrong our side.`,
};

export { formErrors };
